export default "__VITE_PUBLIC_ASSET__10b2022e__"